import * as React from 'react';
import { Image } from '@/hen-ui/atomics/Image';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Text } from '@/hen-ui/atomics/Text';
import { Link } from '@/hen-ui/atomics/Link';
import { Card } from '@/hen-ui/composites/Card';
import { Flex } from '@/hen-ui/composites/Flex';
import { cn } from '@/hen-ui/utils';
import {
  expertBioContainerVariants,
  expertBioImageVariants,
  type ExpertBioContainerVariantProps,
} from './expert-bio.variants';

export interface ExpertBioProps extends ExpertBioContainerVariantProps {
  /**
   * Expert's profile image
   */
  imgSrc: string;

  imgAlt: string;
  /**
   * Expert's name
   */
  name: string;
  /**
   * Expert's occupation
   */
  occupation?: string;
  /**
   * Expert's brand link
   */
  brandLink?: {
    href: string;
    label: string;
  };
  /**
   * Expert's areas of expertise
   */
  expertise?: string;
}

export const ExpertBio: React.FC<ExpertBioProps> = ({
  layout = 'vertical',
  background = 'none',
  imgSrc,
  imgAlt,
  name,
  occupation,
  brandLink,
  expertise,
}) => {
  return (
    <Card
      variant={
        background === 'none' ? 'background-transparent' : 'background-white'
      }
      className={cn(expertBioContainerVariants({ layout, background }))}
    >
      <Image
        src={imgSrc}
        alt={imgAlt}
        rounded={layout === 'horizontal' ? 'md' : 'lg'}
        className={cn(expertBioImageVariants({ layout }))}
      />

      <Flex direction='column' gap='xs'>
        <Heading variant='h5'>{name}</Heading>
        {occupation && (
          <Text variant='b5' color='subtext'>
            {occupation}
          </Text>
        )}
        {brandLink && (
          <Link
            variant='black'
            size='sm'
            href={brandLink.href}
            className='font-bold'
          >
            {brandLink.label}
          </Link>
        )}
        {expertise && (
          <Text variant='b5' color='subtext'>
            {expertise}
          </Text>
        )}
      </Flex>
    </Card>
  );
};
